webpackJsonp([114276838955818,60335399758886],{

/***/ 126:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"Blog - Baris Ozcetin"}}},"layoutContext":{}}

/***/ }),

/***/ 225:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(234);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(126);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 335:
/***/ (function(module, exports, __webpack_require__) {

	var pSlice = Array.prototype.slice;
	var objectKeys = __webpack_require__(337);
	var isArguments = __webpack_require__(336);
	
	var deepEqual = module.exports = function (actual, expected, opts) {
	  if (!opts) opts = {};
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	
	  } else if (actual instanceof Date && expected instanceof Date) {
	    return actual.getTime() === expected.getTime();
	
	  // 7.3. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
	    return opts.strict ? actual === expected : actual == expected;
	
	  // 7.4. For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else {
	    return objEquiv(actual, expected, opts);
	  }
	}
	
	function isUndefinedOrNull(value) {
	  return value === null || value === undefined;
	}
	
	function isBuffer (x) {
	  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
	  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
	    return false;
	  }
	  if (x.length > 0 && typeof x[0] !== 'number') return false;
	  return true;
	}
	
	function objEquiv(a, b, opts) {
	  var i, key;
	  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
	    return false;
	  // an identical 'prototype' property.
	  if (a.prototype !== b.prototype) return false;
	  //~~~I've managed to break Object.keys through screwy arguments passing.
	  //   Converting to array solves the problem.
	  if (isArguments(a)) {
	    if (!isArguments(b)) {
	      return false;
	    }
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return deepEqual(a, b, opts);
	  }
	  if (isBuffer(a)) {
	    if (!isBuffer(b)) {
	      return false;
	    }
	    if (a.length !== b.length) return false;
	    for (i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) return false;
	    }
	    return true;
	  }
	  try {
	    var ka = objectKeys(a),
	        kb = objectKeys(b);
	  } catch (e) {//happens when one is a string literal and the other isn't
	    return false;
	  }
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length != kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] != kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!deepEqual(a[key], b[key], opts)) return false;
	  }
	  return typeof a === typeof b;
	}


/***/ }),

/***/ 336:
/***/ (function(module, exports) {

	var supportsArgumentsClass = (function(){
	  return Object.prototype.toString.call(arguments)
	})() == '[object Arguments]';
	
	exports = module.exports = supportsArgumentsClass ? supported : unsupported;
	
	exports.supported = supported;
	function supported(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	};
	
	exports.unsupported = unsupported;
	function unsupported(object){
	  return object &&
	    typeof object == 'object' &&
	    typeof object.length == 'number' &&
	    Object.prototype.hasOwnProperty.call(object, 'callee') &&
	    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
	    false;
	};


/***/ }),

/***/ 337:
/***/ (function(module, exports) {

	exports = module.exports = typeof Object.keys === 'function'
	  ? Object.keys : shim;
	
	exports.shim = shim;
	function shim (obj) {
	  var keys = [];
	  for (var key in obj) keys.push(key);
	  return keys;
	}


/***/ }),

/***/ 344:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2015 Jed Watson.
	  Based on code that is Copyright 2013-2015, Facebook, Inc.
	  All rights reserved.
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var canUseDOM = !!(
			typeof window !== 'undefined' &&
			window.document &&
			window.document.createElement
		);
	
		var ExecutionEnvironment = {
	
			canUseDOM: canUseDOM,
	
			canUseWorkers: typeof Worker !== 'undefined',
	
			canUseEventListeners:
				canUseDOM && !!(window.addEventListener || window.attachEvent),
	
			canUseViewport: canUseDOM && !!window.screen
	
		};
	
		if (true) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return ExecutionEnvironment;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module !== 'undefined' && module.exports) {
			module.exports = ExecutionEnvironment;
		} else {
			window.ExecutionEnvironment = ExecutionEnvironment;
		}
	
	}());


/***/ }),

/***/ 460:
/***/ (function(module, exports, __webpack_require__) {

	exports.__esModule = true;
	exports.Helmet = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(42);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSideEffect = __webpack_require__(483);
	
	var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);
	
	var _deepEqual = __webpack_require__(335);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _HelmetUtils = __webpack_require__(461);
	
	var _HelmetConstants = __webpack_require__(209);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Helmet = function Helmet(Component) {
	    var _class, _temp;
	
	    return _temp = _class = function (_React$Component) {
	        _inherits(HelmetWrapper, _React$Component);
	
	        function HelmetWrapper() {
	            _classCallCheck(this, HelmetWrapper);
	
	            return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	        }
	
	        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	            return !(0, _deepEqual2.default)(this.props, nextProps);
	        };
	
	        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
	            if (!nestedChildren) {
	                return null;
	            }
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.SCRIPT:
	                case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    return {
	                        innerHTML: nestedChildren
	                    };
	
	                case _HelmetConstants.TAG_NAMES.STYLE:
	                    return {
	                        cssText: nestedChildren
	                    };
	            }
	
	            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
	        };
	
	        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
	            var _extends2;
	
	            var child = _ref.child,
	                arrayTypeChildren = _ref.arrayTypeChildren,
	                newChildProps = _ref.newChildProps,
	                nestedChildren = _ref.nestedChildren;
	
	            return _extends({}, arrayTypeChildren, (_extends2 = {}, _extends2[child.type] = [].concat(arrayTypeChildren[child.type] || [], [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))]), _extends2));
	        };
	
	        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
	            var _extends3, _extends4;
	
	            var child = _ref2.child,
	                newProps = _ref2.newProps,
	                newChildProps = _ref2.newChildProps,
	                nestedChildren = _ref2.nestedChildren;
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.TITLE:
	                    return _extends({}, newProps, (_extends3 = {}, _extends3[child.type] = nestedChildren, _extends3.titleAttributes = _extends({}, newChildProps), _extends3));
	
	                case _HelmetConstants.TAG_NAMES.BODY:
	                    return _extends({}, newProps, {
	                        bodyAttributes: _extends({}, newChildProps)
	                    });
	
	                case _HelmetConstants.TAG_NAMES.HTML:
	                    return _extends({}, newProps, {
	                        htmlAttributes: _extends({}, newChildProps)
	                    });
	            }
	
	            return _extends({}, newProps, (_extends4 = {}, _extends4[child.type] = _extends({}, newChildProps), _extends4));
	        };
	
	        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
	            var newFlattenedProps = _extends({}, newProps);
	
	            Object.keys(arrayTypeChildren).forEach(function (arrayChildName) {
	                var _extends5;
	
	                newFlattenedProps = _extends({}, newFlattenedProps, (_extends5 = {}, _extends5[arrayChildName] = arrayTypeChildren[arrayChildName], _extends5));
	            });
	
	            return newFlattenedProps;
	        };
	
	        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
	            if (false) {
	                if (!_HelmetConstants.VALID_TAG_NAMES.some(function (name) {
	                    return child.type === name;
	                })) {
	                    if (typeof child.type === "function") {
	                        return (0, _HelmetUtils.warn)("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.");
	                    }
	
	                    return (0, _HelmetUtils.warn)("Only elements types " + _HelmetConstants.VALID_TAG_NAMES.join(", ") + " are allowed. Helmet does not support rendering <" + child.type + "> elements. Refer to our API for more information.");
	                }
	
	                if (nestedChildren && typeof nestedChildren !== "string" && (!Array.isArray(nestedChildren) || nestedChildren.some(function (nestedChild) {
	                    return typeof nestedChild !== "string";
	                }))) {
	                    throw new Error("Helmet expects a string as a child of <" + child.type + ">. Did you forget to wrap your children in braces? ( <" + child.type + ">{``}</" + child.type + "> ) Refer to our API for more information.");
	                }
	            }
	
	            return true;
	        };
	
	        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
	            var _this2 = this;
	
	            var arrayTypeChildren = {};
	
	            _react2.default.Children.forEach(children, function (child) {
	                if (!child || !child.props) {
	                    return;
	                }
	
	                var _child$props = child.props,
	                    nestedChildren = _child$props.children,
	                    childProps = _objectWithoutProperties(_child$props, ["children"]);
	
	                var newChildProps = (0, _HelmetUtils.convertReactPropstoHtmlAttributes)(childProps);
	
	                _this2.warnOnInvalidChildren(child, nestedChildren);
	
	                switch (child.type) {
	                    case _HelmetConstants.TAG_NAMES.LINK:
	                    case _HelmetConstants.TAG_NAMES.META:
	                    case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    case _HelmetConstants.TAG_NAMES.SCRIPT:
	                    case _HelmetConstants.TAG_NAMES.STYLE:
	                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
	                            child: child,
	                            arrayTypeChildren: arrayTypeChildren,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	
	                    default:
	                        newProps = _this2.mapObjectTypeChildren({
	                            child: child,
	                            newProps: newProps,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	                }
	            });
	
	            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
	            return newProps;
	        };
	
	        HelmetWrapper.prototype.render = function render() {
	            var _props = this.props,
	                children = _props.children,
	                props = _objectWithoutProperties(_props, ["children"]);
	
	            var newProps = _extends({}, props);
	
	            if (children) {
	                newProps = this.mapChildrenToProps(children, newProps);
	            }
	
	            return _react2.default.createElement(Component, newProps);
	        };
	
	        _createClass(HelmetWrapper, null, [{
	            key: "canUseDOM",
	
	
	            // Component.peek comes from react-side-effect:
	            // For testing, you may use a static peek() method available on the returned component.
	            // It lets you get the current state without resetting the mounted instance stack.
	            // Don’t use it for anything other than testing.
	
	            /**
	            * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
	            * @param {Object} bodyAttributes: {"className": "root"}
	            * @param {String} defaultTitle: "Default Title"
	            * @param {Boolean} defer: true
	            * @param {Boolean} encodeSpecialCharacters: true
	            * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
	            * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
	            * @param {Array} meta: [{"name": "description", "content": "Test description"}]
	            * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
	            * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
	            * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
	            * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
	            * @param {String} title: "Title"
	            * @param {Object} titleAttributes: {"itemprop": "name"}
	            * @param {String} titleTemplate: "MySite.com - %s"
	            */
	            set: function set(canUseDOM) {
	                Component.canUseDOM = canUseDOM;
	            }
	        }]);
	
	        return HelmetWrapper;
	    }(_react2.default.Component), _class.propTypes = {
	        base: _propTypes2.default.object,
	        bodyAttributes: _propTypes2.default.object,
	        children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	        defaultTitle: _propTypes2.default.string,
	        defer: _propTypes2.default.bool,
	        encodeSpecialCharacters: _propTypes2.default.bool,
	        htmlAttributes: _propTypes2.default.object,
	        link: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        meta: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        noscript: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        onChangeClientState: _propTypes2.default.func,
	        script: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        style: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        title: _propTypes2.default.string,
	        titleAttributes: _propTypes2.default.object,
	        titleTemplate: _propTypes2.default.string
	    }, _class.defaultProps = {
	        defer: true,
	        encodeSpecialCharacters: true
	    }, _class.peek = Component.peek, _class.rewind = function () {
	        var mappedState = Component.rewind();
	        if (!mappedState) {
	            // provide fallback if mappedState is undefined
	            mappedState = (0, _HelmetUtils.mapStateOnServer)({
	                baseTag: [],
	                bodyAttributes: {},
	                encodeSpecialCharacters: true,
	                htmlAttributes: {},
	                linkTags: [],
	                metaTags: [],
	                noscriptTags: [],
	                scriptTags: [],
	                styleTags: [],
	                title: "",
	                titleAttributes: {}
	            });
	        }
	
	        return mappedState;
	    }, _temp;
	};
	
	var NullComponent = function NullComponent() {
	    return null;
	};
	
	var HelmetSideEffects = (0, _reactSideEffect2.default)(_HelmetUtils.reducePropsToState, _HelmetUtils.handleClientStateChange, _HelmetUtils.mapStateOnServer)(NullComponent);
	
	var HelmetExport = Helmet(HelmetSideEffects);
	HelmetExport.renderStatic = HelmetExport.rewind;
	
	exports.Helmet = HelmetExport;
	exports.default = HelmetExport;

/***/ }),

/***/ 209:
/***/ (function(module, exports) {

	exports.__esModule = true;
	var ATTRIBUTE_NAMES = exports.ATTRIBUTE_NAMES = {
	    BODY: "bodyAttributes",
	    HTML: "htmlAttributes",
	    TITLE: "titleAttributes"
	};
	
	var TAG_NAMES = exports.TAG_NAMES = {
	    BASE: "base",
	    BODY: "body",
	    HEAD: "head",
	    HTML: "html",
	    LINK: "link",
	    META: "meta",
	    NOSCRIPT: "noscript",
	    SCRIPT: "script",
	    STYLE: "style",
	    TITLE: "title"
	};
	
	var VALID_TAG_NAMES = exports.VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function (name) {
	    return TAG_NAMES[name];
	});
	
	var TAG_PROPERTIES = exports.TAG_PROPERTIES = {
	    CHARSET: "charset",
	    CSS_TEXT: "cssText",
	    HREF: "href",
	    HTTPEQUIV: "http-equiv",
	    INNER_HTML: "innerHTML",
	    ITEM_PROP: "itemprop",
	    NAME: "name",
	    PROPERTY: "property",
	    REL: "rel",
	    SRC: "src"
	};
	
	var REACT_TAG_MAP = exports.REACT_TAG_MAP = {
	    accesskey: "accessKey",
	    charset: "charSet",
	    class: "className",
	    contenteditable: "contentEditable",
	    contextmenu: "contextMenu",
	    "http-equiv": "httpEquiv",
	    itemprop: "itemProp",
	    tabindex: "tabIndex"
	};
	
	var HELMET_PROPS = exports.HELMET_PROPS = {
	    DEFAULT_TITLE: "defaultTitle",
	    DEFER: "defer",
	    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
	    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
	    TITLE_TEMPLATE: "titleTemplate"
	};
	
	var HTML_TAG_MAP = exports.HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function (obj, key) {
	    obj[REACT_TAG_MAP[key]] = key;
	    return obj;
	}, {});
	
	var SELF_CLOSING_TAGS = exports.SELF_CLOSING_TAGS = [TAG_NAMES.NOSCRIPT, TAG_NAMES.SCRIPT, TAG_NAMES.STYLE];
	
	var HELMET_ATTRIBUTE = exports.HELMET_ATTRIBUTE = "data-react-helmet";

/***/ }),

/***/ 461:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {exports.__esModule = true;
	exports.warn = exports.requestAnimationFrame = exports.reducePropsToState = exports.mapStateOnServer = exports.handleClientStateChange = exports.convertReactPropstoHtmlAttributes = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _objectAssign = __webpack_require__(5);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _HelmetConstants = __webpack_require__(209);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
	    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    if (encode === false) {
	        return String(str);
	    }
	
	    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
	};
	
	var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
	    var innermostTitle = getInnermostProperty(propsList, _HelmetConstants.TAG_NAMES.TITLE);
	    var innermostTemplate = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.TITLE_TEMPLATE);
	
	    if (innermostTemplate && innermostTitle) {
	        // use function arg to avoid need to escape $ characters
	        return innermostTemplate.replace(/%s/g, function () {
	            return innermostTitle;
	        });
	    }
	
	    var innermostDefaultTitle = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFAULT_TITLE);
	
	    return innermostTitle || innermostDefaultTitle || undefined;
	};
	
	var getOnChangeClientState = function getOnChangeClientState(propsList) {
	    return getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function () {};
	};
	
	var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[tagType] !== "undefined";
	    }).map(function (props) {
	        return props[tagType];
	    }).reduce(function (tagAttrs, current) {
	        return _extends({}, tagAttrs, current);
	    }, {});
	};
	
	var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[_HelmetConstants.TAG_NAMES.BASE] !== "undefined";
	    }).map(function (props) {
	        return props[_HelmetConstants.TAG_NAMES.BASE];
	    }).reverse().reduce(function (innermostBaseTag, tag) {
	        if (!innermostBaseTag.length) {
	            var keys = Object.keys(tag);
	
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
	                    return innermostBaseTag.concat(tag);
	                }
	            }
	        }
	
	        return innermostBaseTag;
	    }, []);
	};
	
	var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
	    // Calculate list of tags, giving priority innermost component (end of the propslist)
	    var approvedSeenTags = {};
	
	    return propsList.filter(function (props) {
	        if (Array.isArray(props[tagName])) {
	            return true;
	        }
	        if (typeof props[tagName] !== "undefined") {
	            warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + _typeof(props[tagName]) + "\"");
	        }
	        return false;
	    }).map(function (props) {
	        return props[tagName];
	    }).reverse().reduce(function (approvedTags, instanceTags) {
	        var instanceSeenTags = {};
	
	        instanceTags.filter(function (tag) {
	            var primaryAttributeKey = void 0;
	            var keys = Object.keys(tag);
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
	                    primaryAttributeKey = lowerCaseAttributeKey;
	                }
	                // Special case for innerHTML which doesn't work lowercased
	                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attributeKey === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT || attributeKey === _HelmetConstants.TAG_PROPERTIES.ITEM_PROP)) {
	                    primaryAttributeKey = attributeKey;
	                }
	            }
	
	            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
	                return false;
	            }
	
	            var value = tag[primaryAttributeKey].toLowerCase();
	
	            if (!approvedSeenTags[primaryAttributeKey]) {
	                approvedSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!instanceSeenTags[primaryAttributeKey]) {
	                instanceSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!approvedSeenTags[primaryAttributeKey][value]) {
	                instanceSeenTags[primaryAttributeKey][value] = true;
	                return true;
	            }
	
	            return false;
	        }).reverse().forEach(function (tag) {
	            return approvedTags.push(tag);
	        });
	
	        // Update seen tags with tags from this instance
	        var keys = Object.keys(instanceSeenTags);
	        for (var i = 0; i < keys.length; i++) {
	            var attributeKey = keys[i];
	            var tagUnion = (0, _objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
	
	            approvedSeenTags[attributeKey] = tagUnion;
	        }
	
	        return approvedTags;
	    }, []).reverse();
	};
	
	var getInnermostProperty = function getInnermostProperty(propsList, property) {
	    for (var i = propsList.length - 1; i >= 0; i--) {
	        var props = propsList[i];
	
	        if (props.hasOwnProperty(property)) {
	            return props[property];
	        }
	    }
	
	    return null;
	};
	
	var reducePropsToState = function reducePropsToState(propsList) {
	    return {
	        baseTag: getBaseTagFromPropsList([_HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        bodyAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.BODY, propsList),
	        defer: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFER),
	        encode: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
	        htmlAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.HTML, propsList),
	        linkTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.LINK, [_HelmetConstants.TAG_PROPERTIES.REL, _HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        metaTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.META, [_HelmetConstants.TAG_PROPERTIES.NAME, _HelmetConstants.TAG_PROPERTIES.CHARSET, _HelmetConstants.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstants.TAG_PROPERTIES.PROPERTY, _HelmetConstants.TAG_PROPERTIES.ITEM_PROP], propsList),
	        noscriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.NOSCRIPT, [_HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        onChangeClientState: getOnChangeClientState(propsList),
	        scriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.SCRIPT, [_HelmetConstants.TAG_PROPERTIES.SRC, _HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        styleTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.STYLE, [_HelmetConstants.TAG_PROPERTIES.CSS_TEXT], propsList),
	        title: getTitleFromPropsList(propsList),
	        titleAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.TITLE, propsList)
	    };
	};
	
	var rafPolyfill = function () {
	    var clock = Date.now();
	
	    return function (callback) {
	        var currentTime = Date.now();
	
	        if (currentTime - clock > 16) {
	            clock = currentTime;
	            callback(currentTime);
	        } else {
	            setTimeout(function () {
	                rafPolyfill(callback);
	            }, 0);
	        }
	    };
	}();
	
	var cafPolyfill = function cafPolyfill(id) {
	    return clearTimeout(id);
	};
	
	var requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : global.requestAnimationFrame || rafPolyfill;
	
	var cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : global.cancelAnimationFrame || cafPolyfill;
	
	var warn = function warn(msg) {
	    return console && typeof console.warn === "function" && console.warn(msg);
	};
	
	var _helmetCallback = null;
	
	var handleClientStateChange = function handleClientStateChange(newState) {
	    if (_helmetCallback) {
	        cancelAnimationFrame(_helmetCallback);
	    }
	
	    if (newState.defer) {
	        _helmetCallback = requestAnimationFrame(function () {
	            commitTagChanges(newState, function () {
	                _helmetCallback = null;
	            });
	        });
	    } else {
	        commitTagChanges(newState);
	        _helmetCallback = null;
	    }
	};
	
	var commitTagChanges = function commitTagChanges(newState, cb) {
	    var baseTag = newState.baseTag,
	        bodyAttributes = newState.bodyAttributes,
	        htmlAttributes = newState.htmlAttributes,
	        linkTags = newState.linkTags,
	        metaTags = newState.metaTags,
	        noscriptTags = newState.noscriptTags,
	        onChangeClientState = newState.onChangeClientState,
	        scriptTags = newState.scriptTags,
	        styleTags = newState.styleTags,
	        title = newState.title,
	        titleAttributes = newState.titleAttributes;
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.BODY, bodyAttributes);
	    updateAttributes(_HelmetConstants.TAG_NAMES.HTML, htmlAttributes);
	
	    updateTitle(title, titleAttributes);
	
	    var tagUpdates = {
	        baseTag: updateTags(_HelmetConstants.TAG_NAMES.BASE, baseTag),
	        linkTags: updateTags(_HelmetConstants.TAG_NAMES.LINK, linkTags),
	        metaTags: updateTags(_HelmetConstants.TAG_NAMES.META, metaTags),
	        noscriptTags: updateTags(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
	        scriptTags: updateTags(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
	        styleTags: updateTags(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
	    };
	
	    var addedTags = {};
	    var removedTags = {};
	
	    Object.keys(tagUpdates).forEach(function (tagType) {
	        var _tagUpdates$tagType = tagUpdates[tagType],
	            newTags = _tagUpdates$tagType.newTags,
	            oldTags = _tagUpdates$tagType.oldTags;
	
	
	        if (newTags.length) {
	            addedTags[tagType] = newTags;
	        }
	        if (oldTags.length) {
	            removedTags[tagType] = tagUpdates[tagType].oldTags;
	        }
	    });
	
	    cb && cb();
	
	    onChangeClientState(newState, addedTags, removedTags);
	};
	
	var flattenArray = function flattenArray(possibleArray) {
	    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
	};
	
	var updateTitle = function updateTitle(title, attributes) {
	    if (typeof title !== "undefined" && document.title !== title) {
	        document.title = flattenArray(title);
	    }
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.TITLE, attributes);
	};
	
	var updateAttributes = function updateAttributes(tagName, attributes) {
	    var elementTag = document.getElementsByTagName(tagName)[0];
	
	    if (!elementTag) {
	        return;
	    }
	
	    var helmetAttributeString = elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
	    var attributesToRemove = [].concat(helmetAttributes);
	    var attributeKeys = Object.keys(attributes);
	
	    for (var i = 0; i < attributeKeys.length; i++) {
	        var attribute = attributeKeys[i];
	        var value = attributes[attribute] || "";
	
	        if (elementTag.getAttribute(attribute) !== value) {
	            elementTag.setAttribute(attribute, value);
	        }
	
	        if (helmetAttributes.indexOf(attribute) === -1) {
	            helmetAttributes.push(attribute);
	        }
	
	        var indexToSave = attributesToRemove.indexOf(attribute);
	        if (indexToSave !== -1) {
	            attributesToRemove.splice(indexToSave, 1);
	        }
	    }
	
	    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
	        elementTag.removeAttribute(attributesToRemove[_i]);
	    }
	
	    if (helmetAttributes.length === attributesToRemove.length) {
	        elementTag.removeAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    } else if (elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
	        elementTag.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, attributeKeys.join(","));
	    }
	};
	
	var updateTags = function updateTags(type, tags) {
	    var headElement = document.head || document.querySelector(_HelmetConstants.TAG_NAMES.HEAD);
	    var tagNodes = headElement.querySelectorAll(type + "[" + _HelmetConstants.HELMET_ATTRIBUTE + "]");
	    var oldTags = Array.prototype.slice.call(tagNodes);
	    var newTags = [];
	    var indexToDelete = void 0;
	
	    if (tags && tags.length) {
	        tags.forEach(function (tag) {
	            var newElement = document.createElement(type);
	
	            for (var attribute in tag) {
	                if (tag.hasOwnProperty(attribute)) {
	                    if (attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML) {
	                        newElement.innerHTML = tag.innerHTML;
	                    } else if (attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                        if (newElement.styleSheet) {
	                            newElement.styleSheet.cssText = tag.cssText;
	                        } else {
	                            newElement.appendChild(document.createTextNode(tag.cssText));
	                        }
	                    } else {
	                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
	                        newElement.setAttribute(attribute, value);
	                    }
	                }
	            }
	
	            newElement.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, "true");
	
	            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
	            if (oldTags.some(function (existingTag, index) {
	                indexToDelete = index;
	                return newElement.isEqualNode(existingTag);
	            })) {
	                oldTags.splice(indexToDelete, 1);
	            } else {
	                newTags.push(newElement);
	            }
	        });
	    }
	
	    oldTags.forEach(function (tag) {
	        return tag.parentNode.removeChild(tag);
	    });
	    newTags.forEach(function (tag) {
	        return headElement.appendChild(tag);
	    });
	
	    return {
	        oldTags: oldTags,
	        newTags: newTags
	    };
	};
	
	var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
	    return Object.keys(attributes).reduce(function (str, key) {
	        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
	        return str ? str + " " + attr : attr;
	    }, "");
	};
	
	var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
	    var attributeString = generateElementAttributesAsString(attributes);
	    var flattenedTitle = flattenArray(title);
	    return attributeString ? "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
	};
	
	var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
	    return tags.reduce(function (str, tag) {
	        var attributeHtml = Object.keys(tag).filter(function (attribute) {
	            return !(attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT);
	        }).reduce(function (string, attribute) {
	            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute], encode) + "\"";
	            return string ? string + " " + attr : attr;
	        }, "");
	
	        var tagContent = tag.innerHTML || tag.cssText || "";
	
	        var isSelfClosing = _HelmetConstants.SELF_CLOSING_TAGS.indexOf(type) === -1;
	
	        return str + "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
	    }, "");
	};
	
	var convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
	    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(attributes).reduce(function (obj, key) {
	        obj[_HelmetConstants.REACT_TAG_MAP[key] || key] = attributes[key];
	        return obj;
	    }, initProps);
	};
	
	var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
	    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(props).reduce(function (obj, key) {
	        obj[_HelmetConstants.HTML_TAG_MAP[key] || key] = props[key];
	        return obj;
	    }, initAttributes);
	};
	
	var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
	    var _initProps;
	
	    // assigning into an array to define toString function on it
	    var initProps = (_initProps = {
	        key: title
	    }, _initProps[_HelmetConstants.HELMET_ATTRIBUTE] = true, _initProps);
	    var props = convertElementAttributestoReactProps(attributes, initProps);
	
	    return [_react2.default.createElement(_HelmetConstants.TAG_NAMES.TITLE, props, title)];
	};
	
	var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
	    return tags.map(function (tag, i) {
	        var _mappedTag;
	
	        var mappedTag = (_mappedTag = {
	            key: i
	        }, _mappedTag[_HelmetConstants.HELMET_ATTRIBUTE] = true, _mappedTag);
	
	        Object.keys(tag).forEach(function (attribute) {
	            var mappedAttribute = _HelmetConstants.REACT_TAG_MAP[attribute] || attribute;
	
	            if (mappedAttribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || mappedAttribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                var content = tag.innerHTML || tag.cssText;
	                mappedTag.dangerouslySetInnerHTML = { __html: content };
	            } else {
	                mappedTag[mappedAttribute] = tag[attribute];
	            }
	        });
	
	        return _react2.default.createElement(type, mappedTag);
	    });
	};
	
	var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
	    switch (type) {
	        case _HelmetConstants.TAG_NAMES.TITLE:
	            return {
	                toComponent: function toComponent() {
	                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
	                },
	                toString: function toString() {
	                    return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
	                }
	            };
	        case _HelmetConstants.ATTRIBUTE_NAMES.BODY:
	        case _HelmetConstants.ATTRIBUTE_NAMES.HTML:
	            return {
	                toComponent: function toComponent() {
	                    return convertElementAttributestoReactProps(tags);
	                },
	                toString: function toString() {
	                    return generateElementAttributesAsString(tags);
	                }
	            };
	        default:
	            return {
	                toComponent: function toComponent() {
	                    return generateTagsAsReactComponent(type, tags);
	                },
	                toString: function toString() {
	                    return generateTagsAsString(type, tags, encode);
	                }
	            };
	    }
	};
	
	var mapStateOnServer = function mapStateOnServer(_ref) {
	    var baseTag = _ref.baseTag,
	        bodyAttributes = _ref.bodyAttributes,
	        encode = _ref.encode,
	        htmlAttributes = _ref.htmlAttributes,
	        linkTags = _ref.linkTags,
	        metaTags = _ref.metaTags,
	        noscriptTags = _ref.noscriptTags,
	        scriptTags = _ref.scriptTags,
	        styleTags = _ref.styleTags,
	        _ref$title = _ref.title,
	        title = _ref$title === undefined ? "" : _ref$title,
	        titleAttributes = _ref.titleAttributes;
	    return {
	        base: getMethodsForTag(_HelmetConstants.TAG_NAMES.BASE, baseTag, encode),
	        bodyAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
	        htmlAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
	        link: getMethodsForTag(_HelmetConstants.TAG_NAMES.LINK, linkTags, encode),
	        meta: getMethodsForTag(_HelmetConstants.TAG_NAMES.META, metaTags, encode),
	        noscript: getMethodsForTag(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags, encode),
	        script: getMethodsForTag(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags, encode),
	        style: getMethodsForTag(_HelmetConstants.TAG_NAMES.STYLE, styleTags, encode),
	        title: getMethodsForTag(_HelmetConstants.TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }, encode)
	    };
	};
	
	exports.convertReactPropstoHtmlAttributes = convertReactPropstoHtmlAttributes;
	exports.handleClientStateChange = handleClientStateChange;
	exports.mapStateOnServer = mapStateOnServer;
	exports.reducePropsToState = reducePropsToState;
	exports.requestAnimationFrame = requestAnimationFrame;
	exports.warn = warn;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 483:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _exenv = __webpack_require__(344);
	
	var _exenv2 = _interopRequireDefault(_exenv);
	
	var _shallowequal = __webpack_require__(500);
	
	var _shallowequal2 = _interopRequireDefault(_shallowequal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	module.exports = function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
	  if (typeof reducePropsToState !== 'function') {
	    throw new Error('Expected reducePropsToState to be a function.');
	  }
	  if (typeof handleStateChangeOnClient !== 'function') {
	    throw new Error('Expected handleStateChangeOnClient to be a function.');
	  }
	  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
	    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
	  }
	
	  function getDisplayName(WrappedComponent) {
	    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	  }
	
	  return function wrap(WrappedComponent) {
	    if (typeof WrappedComponent !== 'function') {
	      throw new Error('Expected WrappedComponent to be a React component.');
	    }
	
	    var mountedInstances = [];
	    var state = void 0;
	
	    function emitChange() {
	      state = reducePropsToState(mountedInstances.map(function (instance) {
	        return instance.props;
	      }));
	
	      if (SideEffect.canUseDOM) {
	        handleStateChangeOnClient(state);
	      } else if (mapStateOnServer) {
	        state = mapStateOnServer(state);
	      }
	    }
	
	    var SideEffect = function (_Component) {
	      _inherits(SideEffect, _Component);
	
	      function SideEffect() {
	        _classCallCheck(this, SideEffect);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	      }
	
	      // Try to use displayName of wrapped component
	      SideEffect.peek = function peek() {
	        return state;
	      };
	
	      // Expose canUseDOM so tests can monkeypatch it
	
	
	      SideEffect.rewind = function rewind() {
	        if (SideEffect.canUseDOM) {
	          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
	        }
	
	        var recordedState = state;
	        state = undefined;
	        mountedInstances = [];
	        return recordedState;
	      };
	
	      SideEffect.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return !(0, _shallowequal2.default)(nextProps, this.props);
	      };
	
	      SideEffect.prototype.componentWillMount = function componentWillMount() {
	        mountedInstances.push(this);
	        emitChange();
	      };
	
	      SideEffect.prototype.componentDidUpdate = function componentDidUpdate() {
	        emitChange();
	      };
	
	      SideEffect.prototype.componentWillUnmount = function componentWillUnmount() {
	        var index = mountedInstances.indexOf(this);
	        mountedInstances.splice(index, 1);
	        emitChange();
	      };
	
	      SideEffect.prototype.render = function render() {
	        return _react2.default.createElement(WrappedComponent, this.props);
	      };
	
	      return SideEffect;
	    }(_react.Component);
	
	    SideEffect.displayName = 'SideEffect(' + getDisplayName(WrappedComponent) + ')';
	    SideEffect.canUseDOM = _exenv2.default.canUseDOM;
	
	
	    return SideEffect;
	  };
	};

/***/ }),

/***/ 500:
/***/ (function(module, exports) {

	module.exports = function shallowEqual(objA, objB, compare, compareContext) {
	
	    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
	
	    if(ret !== void 0) {
	        return !!ret;
	    }
	
	    if(objA === objB) {
	        return true;
	    }
	
	    if(typeof objA !== 'object' || !objA ||
	       typeof objB !== 'object' || !objB) {
	        return false;
	    }
	
	    var keysA = Object.keys(objA);
	    var keysB = Object.keys(objB);
	
	    if(keysA.length !== keysB.length) {
	        return false;
	    }
	
	    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
	
	    // Test for A's keys different from B.
	    for(var idx = 0; idx < keysA.length; idx++) {
	
	        var key = keysA[idx];
	
	        if(!bHasOwnProperty(key)) {
	            return false;
	        }
	
	        var valueA = objA[key];
	        var valueB = objB[key];
	
	        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
	
	        if(ret === false ||
	           ret === void 0 && valueA !== valueB) {
	            return false;
	        }
	
	    }
	
	    return true;
	
	};


/***/ }),

/***/ 61:
/***/ (function(module, exports) {

	"use strict";
	
	function hash(str) {
	  var hash = 5381,
	      i    = str.length;
	
	  while(i) {
	    hash = (hash * 33) ^ str.charCodeAt(--i);
	  }
	
	  /* JavaScript does bitwise operations (like XOR, above) on 32-bit signed
	   * integers. Since we want the results to be always positive, convert the
	   * signed int to an unsigned by doing an unsigned bitshift. */
	  return hash >>> 0;
	}
	
	module.exports = hash;


/***/ }),

/***/ 62:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(10);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(23);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	Based on Glamor's sheet
	https://github.com/threepointone/glamor/blob/667b480d31b3721a905021b26e1290ce92ca2879/src/sheet.js
	*/
	
	var isProd = ({"NODE_ENV":"production","PUBLIC_DIR":"C:\\Users\\baris_000\\WebProjects\\barisozcetin-blog/public"}) && ("production") === 'production';
	var isString = function isString(o) {
	  return Object.prototype.toString.call(o) === '[object String]';
	};
	
	var StyleSheet = function () {
	  function StyleSheet() {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref$name = _ref.name,
	        name = _ref$name === undefined ? 'stylesheet' : _ref$name,
	        _ref$optimizeForSpeed = _ref.optimizeForSpeed,
	        optimizeForSpeed = _ref$optimizeForSpeed === undefined ? isProd : _ref$optimizeForSpeed,
	        _ref$isBrowser = _ref.isBrowser,
	        isBrowser = _ref$isBrowser === undefined ? typeof window !== 'undefined' : _ref$isBrowser;
	
	    (0, _classCallCheck3.default)(this, StyleSheet);
	
	    invariant(isString(name), '`name` must be a string');
	    this._name = name;
	    this._deletedRulePlaceholder = '#' + name + '-deleted-rule____{}';
	
	    invariant(typeof optimizeForSpeed === 'boolean', '`optimizeForSpeed` must be a boolean');
	    this._optimizeForSpeed = optimizeForSpeed;
	    this._isBrowser = isBrowser;
	
	    this._serverSheet = undefined;
	    this._tags = [];
	    this._injected = false;
	    this._rulesCount = 0;
	  }
	
	  (0, _createClass3.default)(StyleSheet, [{
	    key: 'setOptimizeForSpeed',
	    value: function setOptimizeForSpeed(bool) {
	      invariant(typeof bool === 'boolean', '`setOptimizeForSpeed` accepts a boolean');
	
	      invariant(this._rulesCount === 0, 'optimizeForSpeed cannot be when rules have already been inserted');
	      this.flush();
	      this._optimizeForSpeed = bool;
	      this.inject();
	    }
	  }, {
	    key: 'isOptimizeForSpeed',
	    value: function isOptimizeForSpeed() {
	      return this._optimizeForSpeed;
	    }
	  }, {
	    key: 'inject',
	    value: function inject() {
	      var _this = this;
	
	      invariant(!this._injected, 'sheet already injected');
	      this._injected = true;
	      if (this._isBrowser && this._optimizeForSpeed) {
	        this._tags[0] = this.makeStyleTag(this._name);
	        this._optimizeForSpeed = 'insertRule' in this.getSheet();
	        if (!this._optimizeForSpeed) {
	          if (!isProd) {
	            console.warn('StyleSheet: optimizeForSpeed mode not supported falling back to standard mode.'); // eslint-disable-line no-console
	          }
	          this.flush();
	          this._injected = true;
	        }
	        return;
	      }
	
	      this._serverSheet = {
	        cssRules: [],
	        insertRule: function insertRule(rule, index) {
	          if (typeof index === 'number') {
	            _this._serverSheet.cssRules[index] = { cssText: rule };
	          } else {
	            _this._serverSheet.cssRules.push({ cssText: rule });
	          }
	          return index;
	        },
	        deleteRule: function deleteRule(index) {
	          _this._serverSheet.cssRules[index] = null;
	        }
	      };
	    }
	  }, {
	    key: 'getSheetForTag',
	    value: function getSheetForTag(tag) {
	      if (tag.sheet) {
	        return tag.sheet;
	      }
	
	      // this weirdness brought to you by firefox
	      for (var i = 0; i < document.styleSheets.length; i++) {
	        if (document.styleSheets[i].ownerNode === tag) {
	          return document.styleSheets[i];
	        }
	      }
	    }
	  }, {
	    key: 'getSheet',
	    value: function getSheet() {
	      return this.getSheetForTag(this._tags[this._tags.length - 1]);
	    }
	  }, {
	    key: 'insertRule',
	    value: function insertRule(rule, index) {
	      invariant(isString(rule), '`insertRule` accepts only strings');
	
	      if (!this._isBrowser) {
	        if (typeof index !== 'number') {
	          index = this._serverSheet.cssRules.length;
	        }
	        this._serverSheet.insertRule(rule, index);
	        return this._rulesCount++;
	      }
	
	      if (this._optimizeForSpeed) {
	        var sheet = this.getSheet();
	        if (typeof index !== 'number') {
	          index = sheet.cssRules.length;
	        }
	        // this weirdness for perf, and chrome's weird bug
	        // https://stackoverflow.com/questions/20007992/chrome-suddenly-stopped-accepting-insertrule
	        try {
	          sheet.insertRule(rule, index);
	        } catch (err) {
	          if (!isProd) {
	            console.warn('StyleSheet: illegal rule: \n\n' + rule + '\n\nSee https://stackoverflow.com/q/20007992 for more info'); // eslint-disable-line no-console
	          }
	          return -1;
	        }
	      } else {
	        var insertionPoint = this._tags[index];
	        this._tags.push(this.makeStyleTag(this._name, rule, insertionPoint));
	      }
	
	      return this._rulesCount++;
	    }
	  }, {
	    key: 'replaceRule',
	    value: function replaceRule(index, rule) {
	      if (this._optimizeForSpeed || !this._isBrowser) {
	        var sheet = this._isBrowser ? this.getSheet() : this._serverSheet;
	        if (!rule.trim()) {
	          rule = this._deletedRulePlaceholder;
	        }
	
	        if (!sheet.cssRules[index]) {
	          // @TBD Should we throw an error?
	          return index;
	        }
	
	        sheet.deleteRule(index);
	
	        try {
	          sheet.insertRule(rule, index);
	        } catch (err) {
	          if (!isProd) {
	            console.warn('StyleSheet: illegal rule: \n\n' + rule + '\n\nSee https://stackoverflow.com/q/20007992 for more info'); // eslint-disable-line no-console
	          }
	          // In order to preserve the indices we insert a deleteRulePlaceholder
	          sheet.insertRule(this._deletedRulePlaceholder, index);
	        }
	      } else {
	        var tag = this._tags[index];
	        invariant(tag, 'old rule at index `' + index + '` not found');
	        tag.textContent = rule;
	      }
	      return index;
	    }
	  }, {
	    key: 'deleteRule',
	    value: function deleteRule(index) {
	      if (!this._isBrowser) {
	        this._serverSheet.deleteRule(index);
	        return;
	      }
	
	      if (this._optimizeForSpeed) {
	        this.replaceRule(index, '');
	      } else {
	        var tag = this._tags[index];
	        invariant(tag, 'rule at index `' + index + '` not found');
	        tag.parentNode.removeChild(tag);
	        this._tags[index] = null;
	      }
	    }
	  }, {
	    key: 'flush',
	    value: function flush() {
	      this._injected = false;
	      this._rulesCount = 0;
	      if (this._isBrowser) {
	        this._tags.forEach(function (tag) {
	          return tag && tag.parentNode.removeChild(tag);
	        });
	        this._tags = [];
	      } else {
	        // simpler on server
	        this._serverSheet.cssRules = [];
	      }
	    }
	  }, {
	    key: 'cssRules',
	    value: function cssRules() {
	      var _this2 = this;
	
	      if (!this._isBrowser) {
	        return this._serverSheet.cssRules;
	      }
	      return this._tags.reduce(function (rules, tag) {
	        if (tag) {
	          rules = rules.concat(_this2.getSheetForTag(tag).cssRules.map(function (rule) {
	            return rule.cssText === _this2._deletedRulePlaceholder ? null : rule;
	          }));
	        } else {
	          rules.push(null);
	        }
	        return rules;
	      }, []);
	    }
	  }, {
	    key: 'makeStyleTag',
	    value: function makeStyleTag(name, cssString, relativeToTag) {
	      if (cssString) {
	        invariant(isString(cssString), 'makeStyleTag acceps only strings as second parameter');
	      }
	      var tag = document.createElement('style');
	      tag.type = 'text/css';
	      tag.setAttribute('data-' + name, '');
	      if (cssString) {
	        tag.appendChild(document.createTextNode(cssString));
	      }
	      var head = document.head || document.getElementsByTagName('head')[0];
	      if (relativeToTag) {
	        head.insertBefore(tag, relativeToTag);
	      } else {
	        head.appendChild(tag);
	      }
	      return tag;
	    }
	  }, {
	    key: 'length',
	    get: function get() {
	      return this._rulesCount;
	    }
	  }]);
	  return StyleSheet;
	}();
	
	exports.default = StyleSheet;
	
	
	function invariant(condition, message) {
	  if (!condition) {
	    throw new Error('StyleSheet: ' + message + '.');
	  }
	}

/***/ }),

/***/ 63:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _map = __webpack_require__(95);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _slicedToArray2 = __webpack_require__(97);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _getPrototypeOf = __webpack_require__(96);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(10);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(23);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(36);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(35);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	exports.flush = flush;
	
	var _react = __webpack_require__(2);
	
	var _stylesheetRegistry = __webpack_require__(64);
	
	var _stylesheetRegistry2 = _interopRequireDefault(_stylesheetRegistry);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styleSheetRegistry = new _stylesheetRegistry2.default();
	
	var JSXStyle = function (_Component) {
	  (0, _inherits3.default)(JSXStyle, _Component);
	
	  function JSXStyle() {
	    (0, _classCallCheck3.default)(this, JSXStyle);
	    return (0, _possibleConstructorReturn3.default)(this, (JSXStyle.__proto__ || (0, _getPrototypeOf2.default)(JSXStyle)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(JSXStyle, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      styleSheetRegistry.add(this.props);
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      return this.props.css !== nextProps.css;
	    }
	
	    // To avoid FOUC, we process new changes
	    // on `componentWillUpdate` rather than `componentDidUpdate`.
	
	  }, {
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate(nextProps) {
	      styleSheetRegistry.update(this.props, nextProps);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      styleSheetRegistry.remove(this.props);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }], [{
	    key: 'dynamic',
	    value: function dynamic(info) {
	      return info.map(function (tagInfo) {
	        var _tagInfo = (0, _slicedToArray3.default)(tagInfo, 2),
	            baseId = _tagInfo[0],
	            props = _tagInfo[1];
	
	        return styleSheetRegistry.computeId(baseId, props);
	      }).join(' ');
	    }
	  }]);
	  return JSXStyle;
	}(_react.Component);
	
	exports.default = JSXStyle;
	function flush() {
	  var cssRules = styleSheetRegistry.cssRules();
	  styleSheetRegistry.flush();
	  return new _map2.default(cssRules);
	}

/***/ }),

/***/ 64:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(67);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _classCallCheck2 = __webpack_require__(10);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(23);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _stringHash = __webpack_require__(61);
	
	var _stringHash2 = _interopRequireDefault(_stringHash);
	
	var _stylesheet = __webpack_require__(62);
	
	var _stylesheet2 = _interopRequireDefault(_stylesheet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var sanitize = function sanitize(rule) {
	  return rule.replace(/\/style/ig, '\\/style');
	};
	
	var StyleSheetRegistry = function () {
	  function StyleSheetRegistry() {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref$styleSheet = _ref.styleSheet,
	        styleSheet = _ref$styleSheet === undefined ? null : _ref$styleSheet,
	        _ref$optimizeForSpeed = _ref.optimizeForSpeed,
	        optimizeForSpeed = _ref$optimizeForSpeed === undefined ? false : _ref$optimizeForSpeed,
	        _ref$isBrowser = _ref.isBrowser,
	        isBrowser = _ref$isBrowser === undefined ? typeof window !== 'undefined' : _ref$isBrowser;
	
	    (0, _classCallCheck3.default)(this, StyleSheetRegistry);
	
	    this._sheet = styleSheet || new _stylesheet2.default({
	      name: 'styled-jsx',
	      optimizeForSpeed: optimizeForSpeed
	    });
	
	    this._sheet.inject();
	    if (styleSheet && typeof optimizeForSpeed === 'boolean') {
	      this._sheet.setOptimizeForSpeed(optimizeForSpeed);
	      this._optimizeForSpeed = this._sheet.isOptimizeForSpeed();
	    }
	
	    this._isBrowser = isBrowser;
	
	    this._fromServer = undefined;
	    this._indices = {};
	    this._instancesCounts = {};
	
	    this.computeId = this.createComputeId();
	    this.computeSelector = this.createComputeSelector();
	  }
	
	  (0, _createClass3.default)(StyleSheetRegistry, [{
	    key: 'add',
	    value: function add(props) {
	      var _this = this;
	
	      if (undefined === this._optimizeForSpeed) {
	        this._optimizeForSpeed = Array.isArray(props.css);
	        this._sheet.setOptimizeForSpeed(this._optimizeForSpeed);
	        this._optimizeForSpeed = this._sheet.isOptimizeForSpeed();
	      }
	
	      if (this._isBrowser && !this._fromServer) {
	        this._fromServer = this.selectFromServer();
	        this._instancesCounts = (0, _keys2.default)(this._fromServer).reduce(function (acc, tagName) {
	          acc[tagName] = 0;
	          return acc;
	        }, {});
	      }
	
	      var _getIdAndRules = this.getIdAndRules(props),
	          styleId = _getIdAndRules.styleId,
	          rules = _getIdAndRules.rules;
	
	      // Deduping: just increase the instances count.
	
	
	      if (styleId in this._instancesCounts) {
	        this._instancesCounts[styleId] += 1;
	        return;
	      }
	
	      var indices = rules.map(function (rule) {
	        return _this._sheet.insertRule(rule);
	      })
	      // Filter out invalid rules
	      .filter(function (index) {
	        return index !== -1;
	      });
	
	      if (indices.length > 0) {
	        this._indices[styleId] = indices;
	        this._instancesCounts[styleId] = 1;
	      }
	    }
	  }, {
	    key: 'remove',
	    value: function remove(props) {
	      var _this2 = this;
	
	      var _getIdAndRules2 = this.getIdAndRules(props),
	          styleId = _getIdAndRules2.styleId;
	
	      invariant(styleId in this._instancesCounts, 'styleId: `' + styleId + '` not found');
	      this._instancesCounts[styleId] -= 1;
	
	      if (this._instancesCounts[styleId] < 1) {
	        var tagFromServer = this._fromServer && this._fromServer[styleId];
	        if (tagFromServer) {
	          tagFromServer.parentNode.removeChild(tagFromServer);
	          delete this._fromServer[styleId];
	        } else {
	          this._indices[styleId].forEach(function (index) {
	            return _this2._sheet.deleteRule(index);
	          });
	          delete this._indices[styleId];
	        }
	        delete this._instancesCounts[styleId];
	      }
	    }
	  }, {
	    key: 'update',
	    value: function update(props, nextProps) {
	      this.add(nextProps);
	      this.remove(props);
	    }
	  }, {
	    key: 'flush',
	    value: function flush() {
	      this._sheet.flush();
	      this._sheet.inject();
	      this._fromServer = undefined;
	      this._indices = {};
	      this._instancesCounts = {};
	
	      this.computeId = this.createComputeId();
	      this.computeSelector = this.createComputeSelector();
	    }
	  }, {
	    key: 'cssRules',
	    value: function cssRules() {
	      var _this3 = this;
	
	      var fromServer = this._fromServer ? (0, _keys2.default)(this._fromServer).map(function (styleId) {
	        return [styleId, _this3._fromServer[styleId]];
	      }) : [];
	      var cssRules = this._sheet.cssRules();
	
	      return fromServer.concat((0, _keys2.default)(this._indices).map(function (styleId) {
	        return [styleId, _this3._indices[styleId].map(function (index) {
	          return cssRules[index].cssText;
	        }).join('\n')];
	      }));
	    }
	
	    /**
	     * createComputeId
	     *
	     * Creates a function to compute and memoize a jsx id from a basedId and optionally props.
	     */
	
	  }, {
	    key: 'createComputeId',
	    value: function createComputeId() {
	      var cache = {};
	      return function (baseId, props) {
	        if (!props) {
	          return 'jsx-' + baseId;
	        }
	        var propsToString = String(props);
	        var key = baseId + propsToString;
	        // return `jsx-${hashString(`${baseId}-${propsToString}`)}`
	        if (!cache[key]) {
	          cache[key] = 'jsx-' + (0, _stringHash2.default)(baseId + '-' + propsToString);
	        }
	        return cache[key];
	      };
	    }
	
	    /**
	     * createComputeSelector
	     *
	     * Creates a function to compute and memoize dynamic selectors.
	     */
	
	  }, {
	    key: 'createComputeSelector',
	    value: function createComputeSelector() {
	      var selectoPlaceholderRegexp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : /__jsx-style-dynamic-selector/g;
	
	      var cache = {};
	      return function (id, css) {
	        // Sanitize SSR-ed CSS.
	        // Client side code doesn't need to be sanitized since we use
	        // document.createTextNode (dev) and the CSSOM api sheet.insertRule (prod).
	        if (!this._isBrowser) {
	          css = sanitize(css);
	        }
	        var idcss = id + css;
	        if (!cache[idcss]) {
	          cache[idcss] = css.replace(selectoPlaceholderRegexp, id);
	        }
	        return cache[idcss];
	      };
	    }
	  }, {
	    key: 'getIdAndRules',
	    value: function getIdAndRules(props) {
	      var _this4 = this;
	
	      if (props.dynamic) {
	        var styleId = this.computeId(props.styleId, props.dynamic);
	        return {
	          styleId: styleId,
	          rules: Array.isArray(props.css) ? props.css.map(function (rule) {
	            return _this4.computeSelector(styleId, rule);
	          }) : [this.computeSelector(styleId, props.css)]
	        };
	      }
	
	      return {
	        styleId: this.computeId(props.styleId),
	        rules: Array.isArray(props.css) ? props.css : [props.css]
	      };
	    }
	
	    /**
	     * selectFromServer
	     *
	     * Collects style tags from the document with id __jsx-XXX
	     */
	
	  }, {
	    key: 'selectFromServer',
	    value: function selectFromServer() {
	      var elements = Array.prototype.slice.call(document.querySelectorAll('[id^="__jsx-"]'));
	
	      return elements.reduce(function (acc, element) {
	        var id = element.id.slice(2);
	        acc[id] = element;
	        return acc;
	      }, {});
	    }
	  }]);
	  return StyleSheetRegistry;
	}();
	
	exports.default = StyleSheetRegistry;
	
	
	function invariant(condition, message) {
	  if (!condition) {
	    throw new Error('StyleSheetRegistry: ' + message + '.');
	  }
	}

/***/ }),

/***/ 15:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(63)


/***/ }),

/***/ 228:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ModalContact = undefined;
	
	var _style = __webpack_require__(15);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ModalContact = exports.ModalContact = function (_Component) {
		_inherits(ModalContact, _Component);
	
		function ModalContact() {
			var _temp, _this, _ret;
	
			_classCallCheck(this, ModalContact);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
				name: '',
				email: '',
				message: '',
				formEmailSent: false,
				loading: false
			}, _this.onChange = function (e) {
				var _this$setState;
	
				// e.persist();
				_this.setState((_this$setState = {}, _this$setState[e.target.name] = e.target.value, _this$setState));
			}, _this.onSubmit = function (e) {
				e.preventDefault();
				var _this$state = _this.state,
				    name = _this$state.name,
				    email = _this$state.email,
				    message = _this$state.message;
	
				if (email.trim === '' || message.trim() === '') return false;
				_this.setState({ loading: true });
				var _process$env = ({"NODE_ENV":"production","PUBLIC_DIR":"C:\\Users\\baris_000\\WebProjects\\barisozcetin-blog/public"}),
				    receiverEmail = _process$env.REACT_APP_EMAILJS_RECEIVER,
				    template = _process$env.REACT_APP_EMAILJS_TEMPLATEID;
	
				_this.sendMail(template, name, email, receiverEmail, message);
			}, _this.closeHandler = function (e) {
				_this.setState({
					name: '',
					email: '',
					message: '',
					formEmailSent: false,
					loading: false
				});
				_this.props.handleClose(e);
			}, _temp), _possibleConstructorReturn(_this, _ret);
		}
	
		ModalContact.prototype.sendMail = function sendMail(templateId, name, email, receiverEmail, message) {
			var _this2 = this;
	
			// console.log(name, email, message);
			window.emailjs.send('mailjet', templateId, {
				name: name,
				email: email,
				receiverEmail: receiverEmail,
				message: message
			}).then(function (res) {
				_this2.setState({ formEmailSent: true, loading: false });
			}).catch(function (err) {
				return console.error('Failed to send message. Error: ', err);
			});
		};
	
		ModalContact.prototype.render = function render() {
			var show = this.props.show;
	
			var showClass = show ? 'active' : '';
			var buttonClass = this.state.loading ? 'btn contact__submit loading' : 'btn contact__submit';
			var sendButton = this.state.formEmailSent ? _react2.default.createElement(
				'button',
				{
					className: buttonClass + ' disabled',
					type: 'submit',
					disabled: true,
					style: { color: 'green', fontSize: '1.5rem' }
				},
				'\u2714'
			) : _react2.default.createElement(
				'button',
				{ className: buttonClass, type: 'submit' },
				'Send'
			);
			return _react2.default.createElement(
				'div',
				{ id: 'modal-id', className: 'jsx-874716194' + ' ' + ('modal ' + showClass)
				},
				_react2.default.createElement('a', { 'aria-label': 'Close', onClick: this.closeHandler, className: 'jsx-874716194' + ' ' + 'modal-overlay'
				}),
				_react2.default.createElement(
					'div',
					{
						className: 'jsx-874716194' + ' ' + 'modal-container'
					},
					_react2.default.createElement(
						'div',
						{
							className: 'jsx-874716194' + ' ' + 'modal-body'
						},
						_react2.default.createElement(
							'div',
							{
								className: 'jsx-874716194' + ' ' + 'content'
							},
							_react2.default.createElement(
								'p',
								{ style: { textAlign: 'center' }, className: 'jsx-874716194'
								},
								'You can send an email to ',
								_react2.default.createElement(
									'strong',
									{ style: { fontWeight: 'bold' }, className: 'jsx-874716194'
									},
									'barisozcetin@gmail.com '
								),
								'or contact with form below'
							),
							_react2.default.createElement(
								'form',
								{ method: 'POST', onSubmit: this.onSubmit, style: { paddingTop: '10px' }, className: 'jsx-874716194' + ' ' + 'contact__form'
								},
								_react2.default.createElement('input', {
									type: 'text',
									name: 'name',
									placeholder: 'Your name',
									value: this.state.name,
									onChange: this.onChange,
									autoFocus: true,
									className: 'jsx-874716194'
								}),
								_react2.default.createElement('input', {
									type: 'email',
									name: 'email',
									placeholder: 'Your email',
									required: true,
									value: this.state.email,
									onChange: this.onChange,
									className: 'jsx-874716194'
								}),
								_react2.default.createElement('textarea', {
									name: 'message',
									placeholder: 'Your message',
									required: true,
									value: this.state.message,
									onChange: this.onChange,
									rows: 5,
									className: 'jsx-874716194'
								}),
								sendButton
							)
						)
					),
					_react2.default.createElement(
						'button',
						{
							name: 'close',
	
							style: { '--text-color': '#ffffff' },
							onClick: this.closeHandler,
							className: 'jsx-874716194' + ' ' + 'modal__close'
						},
						'\u2716'
					)
				),
				_react2.default.createElement(_style2.default, {
					styleId: '874716194',
					css: ['modal.jsx-874716194{position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,0.6);z-index:50;}', '.modal-main.jsx-874716194{position:fixed;background:#ebf2ff;width:80%;height:auto;top:50%;left:50%;-webkit-transform:translate(-50%,-50%);-ms-transform:translate(-50%,-50%);transform:translate(-50%,-50%);display:grid;grid-template-rows:auto 1fr;max-height:80vh;z-index:69;padding:15px;}', '.modal__close.jsx-874716194{position:absolute;right:5px;top:5px;border:none;background:none;cursor:pointer;}', '.modal-container.jsx-874716194{position:relative;}', '.display-block.jsx-874716194{display:block;}', '.display-none.jsx-874716194{display:none;}', '.contact__form.jsx-874716194{display:grid;grid-gap:6px;}', '.contact__submit.jsx-874716194{cursor:pointer;outline:none;height:2rem;font-weight:bolder;border-radius:6px;background:#fdfeef;background:-webkit-gradient(linear,left top,left bottom,from(#fdfeef),to(#b1b2a7));background:-moz-linear-gradient(top,#fdfeef,#b1b2a7);background:linear-gradient(to bottom,#fdfeef,#b1b2a7);text-shadow:#ffffff 1px 1px 1px;}', '@media screen and (min-width:768px){.modal-main.jsx-874716194{width:40%;padding:30px;}}', '@media screen and (min-width:1024px){.modal-main.jsx-874716194{width:20%;padding:30px;}}']
				})
			);
		};
	
		return ModalContact;
	}(_react.Component);
	
	exports.default = ModalContact;

/***/ }),

/***/ 231:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _style = __webpack_require__(15);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(83);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _ModalContact = __webpack_require__(228);
	
	var _ModalContact2 = _interopRequireDefault(_ModalContact);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Header = function (_Component) {
		_inherits(Header, _Component);
	
		function Header() {
			var _temp, _this, _ret;
	
			_classCallCheck(this, Header);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
				modalOpen: false
			}, _this.toggleModal = function (e) {
				e.preventDefault();
				e.stopPropagation();
				_this.setState(function (prevState) {
					return { modalOpen: !prevState.modalOpen };
				});
			}, _temp), _possibleConstructorReturn(_this, _ret);
		}
	
		Header.prototype.componentDidMount = function componentDidMount() {
			emailjs.init(({"NODE_ENV":"production","PUBLIC_DIR":"C:\\Users\\baris_000\\WebProjects\\barisozcetin-blog/public"}).REACT_APP_EMAILJS_USERID);
		};
	
		Header.prototype.render = function render() {
			return _react2.default.createElement(
				'nav',
				{
					className: 'jsx-1291808207' + ' ' + 'navbar-container'
				},
				_react2.default.createElement(_ModalContact2.default, { show: this.state.modalOpen, handleClose: this.toggleModal }),
				_react2.default.createElement(
					'section',
					{
						className: 'jsx-1291808207' + ' ' + 'navbar--left'
					},
					_react2.default.createElement(
						_gatsbyLink2.default,
						{ to: '/' },
						_react2.default.createElement(
							'div',
							{
								className: 'jsx-1291808207' + ' ' + 'navbar--logo text-center'
							},
							_react2.default.createElement('img', {
								src: 'https://res.cloudinary.com/dydyt6wbt/image/upload/v1531524115/favicon-256.png',
								alt: '',
								className: 'jsx-1291808207' + ' ' + 'img-responsive'
							}),
							_react2.default.createElement(
								'span',
								{
									className: 'jsx-1291808207' + ' ' + 'logo--link'
								},
								'blog.barisozcetin.me'
							)
						)
					)
				),
				_react2.default.createElement(
					'div',
					{
						className: 'jsx-1291808207' + ' ' + 'spacer'
					},
					_react2.default.createElement('hr', {
						className: 'jsx-1291808207'
					})
				),
				_react2.default.createElement(
					'section',
					{
						className: 'jsx-1291808207' + ' ' + 'navbar--links'
					},
					_react2.default.createElement(
						'button',
						{ to: '/', disabled: true, id: 'subscribe', className: 'jsx-1291808207' + ' ' + 'disabled disabled-link'
						},
						_react2.default.createElement(
							'span',
							{
								className: 'jsx-1291808207' + ' ' + 'text-dark'
							},
							'subscribe'
						)
					),
					_react2.default.createElement(
						'a',
						{ role: 'button', onClick: this.toggleModal, className: 'jsx-1291808207'
						},
						_react2.default.createElement(
							'span',
							{
								className: 'jsx-1291808207' + ' ' + 'text-dark'
							},
							'contact'
						)
					),
					_react2.default.createElement(
						'a',
						{ href: 'https://www.barisozcetin.me', className: 'jsx-1291808207' + ' ' + 'text-dark'
						},
						'barisozcetin.me'
					)
				),
				_react2.default.createElement(_style2.default, {
					styleId: '1291808207',
					css: ['#subscribe.jsx-1291808207{background:none;border:none;}', 'a.jsx-1291808207{cursor:pointer;}', '.navbar-container.jsx-1291808207{display:grid;margin-bottom:20px;margin:0 auto;max-width:1200px;padding:10px 1.0875rem 1.45rem;}', '.navbar--left.jsx-1291808207{justify-items:start;}', '.navbar--logo.jsx-1291808207{display:grid;grid-template-columns:auto auto;grid-gap:10px;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;}', '.logo--link.jsx-1291808207{color:black;font-weight:300;}', '.navbar--links.jsx-1291808207{grid-template-columns:minmax(55px,2fr) minmax(65px,2fr) minmax(100px,3fr);grid-gap:10px;justify-items:center;}', 'hr.jsx-1291808207{margin:10px;border-color:black;}', '.disabled-link.jsx-1291808207{cursor:not-allowed;}', '@media only screen and (min-width:1024px){.navbar-container.jsx-1291808207{grid-template-rows:1fr;grid-template-columns:2fr 1fr;height:140px;padding-top:20px;padding-bottom:20px;}.spacer.jsx-1291808207{display:none;}}', 'section.jsx-1291808207{display:grid;-webkit-align-content:center;-ms-flex-line-pack:center;align-content:center;grid-template-columns:repeat(auto-fit,minmax(250px,1fr));}', 'img.jsx-1291808207{max-height:80px;}']
				})
			);
		};
	
		return Header;
	}(_react.Component);
	
	exports.default = Header;
	module.exports = exports['default'];

/***/ }),

/***/ 234:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _style = __webpack_require__(15);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(42);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(460);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _header = __webpack_require__(231);
	
	var _header2 = _interopRequireDefault(_header);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import './index.css';
	
	var Layout = function Layout(_ref) {
		var children = _ref.children,
		    data = _ref.data;
		return _react2.default.createElement(
			'div',
			{
				className: 'jsx-1525432044'
			},
			_react2.default.createElement(_reactHelmet2.default, {
				title: data.site.siteMetadata.title,
				meta: [{ name: 'description', content: 'Sample' }, { name: 'keywords', content: 'sample, something' }]
			}),
			_react2.default.createElement(_header2.default, { siteTitle: data.site.siteMetadata.title }),
			_react2.default.createElement(
				'div',
				{
					className: 'jsx-1525432044' + ' ' + 'app__content'
				},
				children()
			),
			_react2.default.createElement(_style2.default, {
				styleId: '1525432044',
				css: ['.app__content.jsx-1525432044{margin:0 auto;max-width:1200px;padding-right:5px;padding-left:5px;padding-top:0;}', '@media screen and (min-width:340px){.jsx-1525432044{padding-right:10px;padding-left:10px;}}']
			})
		);
	};
	
	Layout.propTypes = {
		children: _propTypes2.default.func
	};
	
	exports.default = Layout;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-db2a2ab9cfe45e015e9f.js